import { colors, fontStyle } from "Constants";

export const filterDropdownStyle = {
  filterBoxStyle: {
    borderWidth: 0,
    minWidth: "unset",
    padding: 0,
  },
  buttonDropDownContainerStyle: {
    top: "28px",
    zIndex: "20",
  },
  filterTextStyle: {
    ...fontStyle.medium,
    color: colors.neutral300,
    fontSize: "1.4rem",
    marginRight: "0px",
  },
  nameTextStyle: {
    ...fontStyle.bold,
    color: colors.neutral300,
    fontSize: "1.4rem",
  },
  emptyTextStyle: {
    ...fontStyle.bold,
    color: colors.neutral300,
    fontSize: "1.4rem",
  },
  buttonComponentStyle: {
    justifyContent: "center",
  },
  parentContainerStyle: { flex: "1 1" },
  buttonParentStyle: { flex: "1 1" },
};

export const tooltipStyles = {
  tooltipStyle: { cursor: "pointer", color: null },
};
